module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-box",
    class: {
      show: !_vm.backErrors
    }
  }, [_vm._v("\n    " + _vm._s(_vm.backErrors) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f4ef26","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errorMsg.vue
// module id = 500
// module chunks = 0 4 5 7 8 10